__webpack_require__.p = "/contestbigo/";